import React, { useState, useEffect, useCallback } from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ReactPaginate from 'react-paginate';
import Iframe from 'react-iframe';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import authCheck, {
  getPpaService,
  getPpaProduct,
  putPpaDisplayPatternId,
  getPpaSid
} from '../../util/callApi.js';
import checkTermsVer from '../../util/checkTermsVer.js';
import LapDialog from '../../util/laplaceDialog.js';
import findLocalStorage from '../../util/findLocalStorage.js';

import {
  PPA_PRODUCTLIST_NUM,
  API_STATUS,
  TERM_VER
} from '../../../configures/val.js';

import clipboard from 'clipboard';
new clipboard('.ppaUrlCopyButton');

function PpaProductsList(props) {
  const [isHighlight, setHighlight] = useState(false);
  const [serviceData, setServiceData] = useState({});
  const [termError, setTermError] = useState(false); // 利用規約のポップアップ状態を管理
  const [serviceDataApiStatus, setServiceDataApiStatus] = useState(API_STATUS.LOADING);
  const [products, setProducts] = useState([]);
  const [productsApiStatus, setProductsApiStatus] = useState(API_STATUS.LOADING);
  const [authzApiStatus, setAuthzApiStatus] = useState(API_STATUS.LOADING);
  const [isSnackShow, setSnackShow] = useState(false);
  const [pagenationMax, setPagenationMax] = useState(0);
  const [query, setQuery] = useState('');
  const [isKickGetService, setIsKickGetService] = useState(false);
  const [isKickGetProduct, setIsKickGetProduct] = useState(false);
  const [pattern, setPattern] = useState([]);
  const [isOnIframe, setOnIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [supplierId, setSupplierId] = useState('');
  const [supplierList, setSupplierList] = useState([]);

  // ヘッダハイライト
  useEffect(() => {
    if (!isHighlight) {
      props.updateHeader();
      setHighlight(true);
    }
  }, [props, isHighlight])
  // Authz へのアクセス
  useEffect(() => {
    async function callApi() {
      let authzRet = {};
      if (authzApiStatus === API_STATUS.LOADING) {
        authzRet = await getPpaSid();
        if (authzRet.result === 'NG' || authzRet.data.supplier_ids.length === 0) {
          setAuthzApiStatus(API_STATUS.NO_BODY);
          return;
        } else if (authzRet.result === 'OK'){
          // NG でないなら data 内の値を使ってデータ取得を進める
          setAuthzApiStatus(API_STATUS.OK);
          const supplierIds = authzRet.data.supplier_ids;
          if (supplierIds.length > 1) {
            let supplierList = Array(supplierIds.length);
            for (let i = 0; i < supplierIds.length; i++) {
              let serviceRet = await getPpaService(supplierIds[i]);
              if (serviceRet.result === 'NG') {
                setServiceDataApiStatus(API_STATUS.NO_BODY);
                break;
              }
              supplierList[i] = {
                supplierId: supplierIds[i],
                serviceName: serviceRet.data.serviceName
              };
            }
            setSupplierList(supplierList);
          }
          if (props.supplierId !== null) {
            if (supplierIds.includes(props.supplierId)) {
              setSupplierId(props.supplierId);
            } else {
              props.signOut();
            }
          } else {
            props.updateSupplierId(supplierIds[0]);
            setSupplierId(supplierIds[0]);
          }
        }
      }
    }
    callApi();
  }, [authzApiStatus, props]);
  // ServiceAPI の呼び出し
  useEffect(() => {
    async function callApi() {
      if (serviceDataApiStatus === API_STATUS.LOADING || isKickGetService) {
        setIsKickGetService(false);
        const serviceRet = await getPpaService(supplierId);
        assignServiceResponse(serviceRet);
      }
    }
    if (authzApiStatus === API_STATUS.OK && supplierId.length > 0) {
      callApi();
    }
  }, [authzApiStatus, supplierId, serviceDataApiStatus, isKickGetService]);
  // ProductAPI の呼び出し
  useEffect(() => {
    function makeArg() {
      if (query.length >= 1) {
        return {
          supplierId,
          limit: PPA_PRODUCTLIST_NUM,
          query
        }
      }
      return {
        supplierId,
        limit: PPA_PRODUCTLIST_NUM,
      }
    }
    async function callApi() {
      if (
        productsApiStatus === API_STATUS.LOADING ||
        isKickGetProduct
      ) {
        setIsKickGetProduct(false);
        const arg = makeArg();
        const productRet = await getPpaProduct(arg);
        if(productRet.result === 'OK') {
          setProductsApiStatus(API_STATUS.OK);
          setProducts(productRet.data.products);
          setPagenationMax(calcPagenationMaxLength(productRet.data.count));
        } else {
          setProductsApiStatus(API_STATUS.NO_BODY);
          setProducts([]);
          setPagenationMax(calcPagenationMaxLength(0));
        }
      }
    }
    if (authzApiStatus === API_STATUS.OK && supplierId.length > 0) {
      callApi();
    }
  }, [authzApiStatus, supplierId, productsApiStatus, query, isKickGetProduct]);
  useEffect(() => {
    const makePatternArr = (products) => {
      const leng = products.length;
      let patternArr = Array(leng);
      for (let i = 0; i < leng; i++) {
        patternArr[i] = products[i].displayPatternId
      }
      return patternArr;
    }
    setPattern(makePatternArr(products));
  }, [products]);
  // 認証ステータスと利用規約のバージョンを確認
  const confirmUserStatus = useCallback(async() => {
    const authRet = await authCheck();
    if (authRet.result === 'NG') {
      props.authStateChange('signIn');
      return true;
    }
    const isLowVer = checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
    if (isLowVer) {
      setTermError(true);
      return true;
    }
    return false;
  }, [props]);
  useEffect(() => {
    confirmUserStatus();
  }, [confirmUserStatus]);
  const assignServiceResponse = (serviceRet) => {
    if(serviceRet.result === 'OK') {
      setServiceData(serviceRet.data);
      setServiceDataApiStatus(API_STATUS.OK);
    } else if(serviceRet.result === 'NG') {
      setServiceDataApiStatus(API_STATUS.NO_BODY);
    }
  }
  const toggleSnackShow = () => {
    setSnackShow(!isSnackShow);
  }
  const searchByEnterKey = (e) => {
    const {key} = e;
    if (key !== 'Enter') {
      return;
    }
    search();
  }
  const search = async() => {
    if (await confirmUserStatus()) {
      return;
    }
    setIsKickGetProduct(true);
  }
  const setSearchQuery = (e) => {
    const {value} = e.target;
    setQuery(value);
  }
  async function getPagenationProducts(toPage) {
    if (await confirmUserStatus()) {
      return;
    }
    const params = {
      supplierId,
      limit: PPA_PRODUCTLIST_NUM,
      offset: toPage
    }
    let result = await getPpaProduct(params);
    setProducts(result.data.products);
  }
  // pattern 配列を i 番目に e.targetが が入った状態で作り直す
  const updatePattern = async (e, i, pId) => {
    async function putDisplay(pId, dpId) {
      if (await confirmUserStatus()) {
        return;
      }
      const param = {
        displayPatternId: dpId
      }
      const ret = await putPpaDisplayPatternId(pId, param);
      return ret;
    }
    const {value} = e.target;
    const ret = await putDisplay(pId, value);
    if (!ret) {
      return;
    }
    if (ret.result === 'OK') {
      let updPattern = pattern.concat();
      updPattern[i] = value;
      setPattern(updPattern);
    } else if(ret.result === 'NG') {
      alert(I18n.get('Failed to set pattern.'));
    }
  }
  const turnIframe = async (pid) => {
    if (await confirmUserStatus()) {
      return;
    }
    const idt = findLocalStorage('idToken');
    const url = serviceData.serviceUrl + '?idt=' + idt + '&pid=' + pid;
    setIframeUrl(url);
    setOnIframe(!isOnIframe);
  }

  // == render() ==
  const renderSelect = (plans, selectedId, i, pId) => {
    return(
      <div className="ppaAssetSelector">
        <select name="pattern" value={selectedId} onChange={(e) => updatePattern(e, i, pId)}>
          {plans.map((data, plansi) => {
            return(
              <option key={`Option_${pId}_${plansi}`} value={data.id}>{data.name}</option>
            );
          })}
        </select>
      </div>
    );
  }
  const renderLabel = (arg) => {
    return(
      <>{arg[0].name}</>
    )
  }
  const renderTable = () => {
    if(productsApiStatus === API_STATUS.NO_BODY) {
      return(
        <p>
          {I18n.get('Power plant data could not be obtained.')}
        </p>
      );
    }
    let plans = [];
    for (let i = 0; i < serviceData.displayPatterns.length; i++) {
      const obj = {
        name: serviceData.displayPatterns[i].patternName,
        id: serviceData.displayPatterns[i].id,
      };
      plans.push(obj);
    }
    return (
    <>
      {products.map((data, i) => {
        return (
          <TableRow key={`Table_${data.productId}_${i}`}>
            <TableCell className="tItem t_name"><a href={data.siteUrl}>{data.siteName}</a></TableCell>
            <TableCell className="tItem t_mac">{data.macAddress}</TableCell>
            <TableCell className="tItem t_serial">{data.serialNumber}</TableCell>
            <TableCell className="tItem t_pattern">
              {plans.length > 1 ? renderSelect(plans, pattern[i], i, data.productId) : renderLabel(plans)}
            </TableCell>
            <TableCell className="tItem t_screen textCenter"><button className="ppaNoabsoluteNormalButton" onClick={() =>turnIframe(data.productId)}>{I18n.get('Show')}</button></TableCell>
            <TableCell className="tItem t_state"><span className={data.userRegistered ? "select" : ""}>{data.userRegistered ? I18n.get('Registered') : I18n.get('Unregistered')}</span></TableCell>
          </TableRow>
        );
      })}
    </>
    )
  }
  const closeDialog = () => {
    props.authStateChange('reagreeTermsDocs');
  }

  // authzdb API でエラー時の表示
  if (authzApiStatus === API_STATUS.NO_BODY) {
    return (
      <p>{I18n.get('Failed to confirm company you belong.')}</p>
    );
  }
  // サービス API でエラー時の表示
  if (serviceDataApiStatus === API_STATUS.NO_BODY) {
    return (
      <p>{I18n.get('Service data could not be obtained.')}</p>
    );
  }
  // ロード中
  if (
    authzApiStatus === API_STATUS.LOADING ||
    serviceDataApiStatus === API_STATUS.LOADING ||
    productsApiStatus === API_STATUS.LOADING
  ) {
    return (
      <p>{I18n.get('Now loading...')}</p>
    );
  }

  // 事業者の選択を変更したら、その事業者 ID に合わせて Service と Product を取り直す
  const updateSupplierId = async (e) => {
    props.updateSupplierId(e.target.value);
    setSupplierId(e.target.value);
    setIsKickGetService(true)
    setIsKickGetProduct(true);
  }
  // 複数の事業者を切り替えるプルダウン
  const showSupplierSelector = () => {
    return (
      <div className="supplierArea">
        <p>{I18n.get('Supplier')}</p>
        <div className="supplierSelector">
          <select name="supplier" value={supplierId} onChange={(e) => updateSupplierId(e)}>
            {supplierList.map((supplierInfo, i) => {
              const keyStr = `supplierOption${i}`;
              return (
                <option key={keyStr} value={supplierInfo.supplierId}>
                  {supplierInfo.serviceName}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    );
  }

  return (
    <div className="ppaProductListContainer">
      <div className="mypageContainer">
        <div className='mypageBreadcrumbs'>
          <Link to='/servicelist'>{I18n.get('Service list')}</Link>&nbsp;&nbsp;＞&nbsp;&nbsp;{I18n.get('Product list')}
        </div>
        {supplierList.length > 1 ? showSupplierSelector() : ''}
        <div className="urlCopyArea">
          <span>{serviceData.hasOwnProperty('serviceUrl') ? serviceData.serviceUrl : ''}</span>
          <button
            onClick={toggleSnackShow}
            className="ppaUrlCopyButton"
            data-clipboard-text={serviceData.serviceUrl}
          >
            {I18n.get('Copy URL')}
          </button>
        </div>
        <div className="searchArea">
          <p>{I18n.get('Search by: ') + I18n.get('Power Plant Name (Site Name)') + ', ' + I18n.get('MAC Address') + ', '+ I18n.get('Serial Number (S/N)')}</p>
          <input type="text" value={query} onChange={(e) => setSearchQuery(e)} onKeyDown={(e) => searchByEnterKey(e)}/>
          <button onClick={search}>{I18n.get('Search')}</button>
        </div>
        <Table className="productTable">
          <TableHead>
            <TableRow className="trItem">
              <TableCell className="tItem t_name" rowSpan="2">{I18n.get('Power Plant Name (Site Name)')}</TableCell>
              <TableCell className="tItem t_mac" rowSpan="2">{I18n.get('MAC Address')}</TableCell>
              <TableCell className="tItem t_cereal" rowSpan="2">{I18n.get('Serial Number (S/N)')}</TableCell>
              <TableCell className="tItem t_pattern" rowSpan="2">{I18n.get('Pattern')}</TableCell>
              <TableCell className="tItem t_user" colSpan="2">{I18n.get('Ppa Contents User')}</TableCell>
            </TableRow>
            <TableRow className="trItem">
              <TableCell className="tItem t_screen">{I18n.get('Screen')}</TableCell>
              <TableCell className="tItem t_state">{I18n.get('Usage Status')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {renderTable()}
          </TableBody>
        </Table>
        <ReactPaginate
          previousLabel={I18n.get('Previous')}
          nextLabel={I18n.get('Next')}
          breakLabel={'...'}
          breakClassName={'breakLink'}
          pageCount={pagenationMax}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={(ret) => {getPagenationProducts(ret.selected);}}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isSnackShow}
        autoHideDuration={7000}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={I18n.get('Link url is copied')}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={toggleSnackShow}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
      <Dialog
        open={isOnIframe}
        fullScreen={true}
      >
        <DialogContent>
          <AppBar>
            <Toolbar className='L_menuBarBack'>
              <IconButton edge="start" color="inherit" onClick={() => setOnIframe(!isOnIframe)} aria-label="close">
                <CloseIcon />
              </IconButton>
              <p>
                {I18n.get('[Sample] This is display image as user')}
              </p>
            </Toolbar>
          </AppBar>
          <div className="ppaUserviewIframe"></div>
          <Iframe url={iframeUrl} width='100%' height='100%'/>
        </DialogContent>
      </Dialog>
      <LapDialog
        title={''}
        contentElem={
          <div>
          <p>{I18n.get('Terms of Service is updated.')}</p>
          <p>{I18n.get('Please reconfirm it.')}</p>
          </div>
        }
        firstButtonText={'OK'}
        firstButtonFunc={() => closeDialog()}
        open={termError}
        toClose={() => {return}}
      />
    </div>
  );
}
function calcPagenationMaxLength(productCount) {
  let ret = Math.floor(productCount / PPA_PRODUCTLIST_NUM);
  if ((productCount % PPA_PRODUCTLIST_NUM) > 0) {
    ret++;
  }
  return ret;
}
export default PpaProductsList;
